<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <mat-select #inputSelect [formControl]="control" class="ag-input-field-input"
              [placeholder]="control.value.label" (selectionChange)="stopEditing()">
    @if (optional) {
      <mat-option [value]="''">{{ 'LABEL.UNDEFINED' | translate }}</mat-option>
    }
    @for (entity of selectOptions; track entity.optionValue) {
      <mat-option [value]="entity.optionValue">
        {{ entity.label }}
      </mat-option>
    }
  </mat-select>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }
</div>
